import {
  fade, makeStyles
} from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '80%',
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '95%'
    }
  },
  addBtn: {
    padding: '3rem 0',
    textTransform: 'uppercase',
    '& button span svg': {
      color: 'white'
    }
  },
  btn: {
    marginRight: '1rem'
  },
  title_identity: {
    color: 'rgba(0,0,0,0.60)'
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    padding: '1rem 0',
    boxShadow: 'none',
    color: '#CFD5E5'
  },
  cardMedia: {
    width: '4rem',
    height: '4rem',
    borderRadius: '100%',
    marginRight: '1rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  search: {
    position: 'relative',
    height: '40px',
    borderRadius: theme.shape.borderRadius,
    marginLeft: 0,
    width: '100%',
    marginBottom: '50px',
    [theme.breakpoints.up('sm')]: {
      width: 'auto'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputRoot: {
    color: 'inherit',
    height: '100%',
    width: '100%'
  },
  inputInput: {
    border: '2px solid #C4CDCE',
    borderRadius: '4px',
    height: '100%',
    padding: 0,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    '&:focus': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '50%',
      '&:focus': {
        width: '55%'
      }
    },
    [theme.breakpoints.up('md')]: {
      width: '40%',
      '&:focus': {
        width: '45%'
      }
    },
    [theme.breakpoints.up('lg')]: {
      width: '35%',
      '&:focus': {
        width: '40%'
      }
    },
    [theme.breakpoints.down('md')]: {
      width: '50%',
      '&:focus': {
        width: '55%'
      }
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  }
}));
